import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/AdminShell";
import { AdminPushStatus } from "@/components/AdminPushStatus";

export const Route = createFileRoute("/_authenticated/admin/pushnotiser")({
  head: () => ({
    meta: [
      { title: "Pushnotiser — Administration" },
      {
        name: "description",
        content: "Internt: status, enheter och kö för pushnotiser i Sellavo.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Pushnotiser — Administration" },
      {
        property: "og:description",
        content: "Status, enheter och kö för pushnotiser.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <AdminShell title="Pushnotiser">
      <AdminPushStatus />
    </AdminShell>
  ),
});
